import React from 'react';
import './styles.css';
import ReactDOM from 'react-dom';
import Random from '../../utils/strings/Random';

class ModalBox extends React.Component{
  constructor(props) {
    super(props);
    this.MODAL_CLASS_IN = "__react-modal-in__";


    this.handleKeyUp = this.handleKeyUp.bind(this);
    this.handlerClose = this.handlerClose.bind(this);
    this.close = this.close.bind(this);
  }

  componentDidMount() {
    this.addClassModalIn();
    window.addEventListener('keyup', this.handleKeyUp, false);
  }

//
  close(){
    this.closeModal();
  }

//bt close handler
  handlerClose (e){
    this.closeModal();
  }

//add class MODAL_CLASS_IN to body and make overflow hidden to prevent page scrolling
  addClassModalIn (){
    var _body = document.body;
    _body.classList ? _body.classList.add(this.MODAL_CLASS_IN) : _body.className += ' '+this.MODAL_CLASS_IN;
  }

//remove class MODAL_CLASS_IN to body and make overflow hidden to prevent page scrolling
  removeClassIn (){
    var _body = document.body;
    _body.classList.remove(this.MODAL_CLASS_IN);
  }

//esc key remove modal
  handleKeyUp(e) {
    const keys = {
      27: () => {
        e.preventDefault();
        this.closeModal();
        window.removeEventListener('keyup', this.handleKeyUp, false);
      },
    };

    if (keys[e.keyCode]) { keys[e.keyCode](); }
  }

//close modal
  closeModal (){
    this.removeClassIn();
    var _id = this.props.id;
    var elem = document.getElementById(_id);
    elem.classList.remove('in');
    setTimeout(function(){
      ReactDOM.unmountComponentAtNode(elem);
      elem.remove();
    },300);
  }

  render () {
    return (
        <div className="__modal__">
          <div className="__modal-box__">
            <button onClick={this.handlerClose} className="__modal-button-close__"><i className="fas fa-times"></i></button>
            <div className="__modal-box-inner__">
            {this.props.page}
            </div>
          </div>
        </div>
    );
  }
};

const MODAL_CLASS_WRAPPER = "__react-modal-class__";


class Modal {
  constructor(__args__) {
    //this.init(__args__);

  }

  close (){
    this.modal.close();
  }

  open(__props__){
    //create an element that will create our overlay
    const container = document.createElement("div");
    var _randomId = Random(5);
    container.setAttribute("id", _randomId);
    container.setAttribute("class", MODAL_CLASS_WRAPPER);
    document.body.appendChild(container);

    var overlay = ReactDOM.render(<ModalBox id={_randomId} page={__props__.page} />, document.getElementById(_randomId));
    this.modal = overlay;

    setTimeout(function(){
      container.classList.add('in');
    },10);
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/modal/Modal.js